import React from 'react';
import { useTranslations } from 'next-intl';

import { useProPackagePrice } from 'modules/pro/hooks';

interface IProps {
  plan: number | null;
}

const PlanBlock: React.FC<IProps> = ({ plan }) => {
  const t = useTranslations();
  const { packagePrice } = useProPackagePrice();

  return (
    <div className="mt-6.5 space-y-2 rounded-xl border border-white p-4">
      <div className="flex items-center justify-between text-white">
        <span>
          {plan} {t('oylik')} premium
        </span>
        <span className="text-gray-400">{packagePrice?.[plan as number]}</span>
      </div>
      <div className="flex items-center justify-between text-white">
        <span className="capitalize">{t('chegirma')}</span>
        <span className="text-gray-400">0</span>
      </div>
      <div className="flex items-center justify-between text-white">
        <span>{t('tolanadigan_summa')}</span>
        <span>{packagePrice?.[plan as number]}</span>
      </div>
    </div>
  );
};

export default PlanBlock;
